var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_20344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7984 10.7348L21.3984 7.13437C21.176 6.80039 20.8012 6.59995 20.4 6.59995H15.6V5.39995C15.6 4.73714 15.0628 4.19995 14.4 4.19995H1.2C0.537188 4.2 0 4.73719 0 5.4V16.2C0 16.8628 0.537188 17.4 1.2 17.4H4.2608C4.53961 18.7676 5.75119 19.8 7.2 19.8C8.64881 19.8 9.86039 18.7676 10.1392 17.4H15.6608C15.9396 18.7676 17.1512 19.8 18.6 19.8C20.0488 19.8 21.2604 18.7676 21.5392 17.4H22.8C23.4628 17.4 24 16.8628 24 16.2V11.4004C24 11.1636 23.93 10.932 23.7984 10.7348ZM7.2 18.6C6.20602 18.6 5.4 17.794 5.4 16.8C5.4 15.806 6.20602 15 7.2 15C8.19398 15 9 15.806 9 16.8C9 17.794 8.19398 18.6 7.2 18.6ZM14.4 16.2H10.1392C9.86039 14.8324 8.64881 13.8 7.2 13.8C5.75119 13.8 4.53961 14.8324 4.2608 16.2H1.2V15H2.4V13.8H1.2V5.4H14.4V16.2ZM15.6 7.8H20.4L22.5448 11.0176L19.3456 10.2176C19.298 10.206 19.2492 10.2 19.2 10.2H15.6V7.8ZM18.6 18.6C17.606 18.6 16.8 17.794 16.8 16.8C16.8 15.806 17.606 15 18.6 15C19.594 15 20.4 15.806 20.4 16.8C20.4 17.794 19.594 18.6 18.6 18.6ZM22.8 13.2H21.6V14.4H22.8V16.2H21.5392C21.2604 14.8324 20.0488 13.8 18.6 13.8C17.1512 13.8 15.9396 14.8324 15.6608 16.2H15.6V11.4H19.126L22.8 12.3188V13.2Z",
    fill: "#005EB8",
    stroke: "#005EB8",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_20344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.7bf0062819145a9d09ff72525b1d910e.svg";
export { ForwardRef as ReactComponent };